import React from 'react';
export function Footer() {
  return <footer className="bg-charcoal text-white py-12 border-t-4 border-gold" data-id="element-144">
      <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-145">
        <div className="mb-6" data-id="element-146">
          <h2 className="font-serif font-bold text-2xl tracking-wide mb-2" data-id="element-147">
            🌙 ZENTRAL PRO™
          </h2>
          <p className="text-gray-400 max-w-lg mx-auto text-sm" data-id="element-148">
            El sistema de sueño infantil N°1 para familias argentinas. Porque
            las noches de tu familia merecen un sistema — no más improvisación.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-8 text-base text-gray-300 mb-8" data-id="element-149">
          <a href="mailto:soporte.zentralpro@gmail.com" className="hover:text-gold transition-colors" data-id="element-150">
            soporte.zentralpro@gmail.com
          </a>
          <span className="hidden sm:inline text-gray-600" data-id="element-151">|</span>
          <a href="https://instagram.com/_zentralpro" className="hover:text-gold transition-colors" data-id="element-152">
            @_zentralpro
          </a>
          <span className="hidden sm:inline text-gray-600" data-id="element-153">|</span>
          <a href="https://descanso.zentralpro.store" className="hover:text-gold transition-colors" data-id="element-154">
            descanso.zentralpro.store
          </a>
        </div>

        <div className="border-t border-white/10 pt-8 text-sm text-gray-500" data-id="element-155">
          <p data-id="element-156">
            © Zentral Pro™ 2026 — Todos los derechos reservados. Prohibida la
            reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}